import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import { Box, Tabs } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import Banners from 'modules/expenses/components/expenses/PageContents/_Banners'
import Header from 'modules/expenses/components/expenses/PageContents/_Header'
import { useExpensesNavigation } from 'modules/expenses/hooks/useExpensesNavigation'
import { useExpenses } from 'modules/expenses/pages/ExpensesContext'

import { QuickFiltersProvider } from './QuickFiltersContext'

interface ContentProps {
  expensableGroupsEnabled: boolean
}

const Content = ({ children, expensableGroupsEnabled }: React.PropsWithChildren<ContentProps>) => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const { tab } = useExpensesNavigation()
  const searchParams = new URLSearchParams(location.search)

  const {
    featureAvailabilities: { dataCollectionEnabled },
  } = useExpenses()

  const navigationTab = (value: string) => {
    switch (value) {
      case 'expenses':
        navigate({
          pathname: navigation.expenses.list.expenses.fullPath(),
          search: searchParams.toString(),
        })
        break
      case 'groups':
        navigate({
          pathname: navigation.expenses.list.groups.fullPath(),
          search: searchParams.toString(),
        })
        break
    }
  }

  return (
    <QuickFiltersProvider>
      <Box alignItems="center" justifyContent="center">
        <Box gap="s16" width="full">
          <Banners />
          {!dataCollectionEnabled && (
            <Header title={i18n.t('expenses_v2.tabs.expenses')} filterType={'pending'} />
          )}
          <Box gap="s16">
            {expensableGroupsEnabled && (
              <Tabs currentId={tab} onTabClicked={navigationTab}>
                <Tabs.Tab id="expenses" label={i18n.t('expenses_v2.list.tabs.expenses')} default />
                <Tabs.Tab id="groups" label={i18n.t('expenses_v2.list.tabs.groups')} />
              </Tabs>
            )}
          </Box>
          {children}
        </Box>
      </Box>
    </QuickFiltersProvider>
  )
}

export default Content
